import React from "react";



export default function WelcomePage() {
  return (
    <section className="home-page">
      <header>
        <h1 className="market-h1">Sauti Africa</h1>
        <h2 className = "produce-h2">Produce
</h2>
        <p className = "market-p">fruits 4.45R</p>
        <p className = "market-p">vegetables 6.45R</p>
        <p className = "market-p">meats 9.75R</p>
        <p className = "market-p">dairy 3.47R</p>
        <p className = "market-p">fruits 4.45R</p>
       
        <h2 className = "clothing-h2">Clothing
</h2>
<p className = "clothing-p">mens 10.45R</p>
        <p className = "clothing-p">womens 8.45R</p>
        <p className = "clothing-p">kids 9.55R</p>
    

        <h2 className = "household-h2">Household
</h2>
<p className = "household-p">furniture 10.45R</p>
        <p className = "household-p">cookware 8.45R</p>
        <p className = "household-p"> decor 9.55R</p>
        <p className = "household-p"> electronics 15.55R</p>
    
      </header>
    </section>
  );
}